import { api } from "./api/client";
import type { GrowthResponse } from "./api/types";

/**
 * 增长's reports, kept for the visit and shared by its pages (owner 10/10:
 * 「优化一下加载速度现在的卡卡的」). Each page asked again for a report another had
 * just been given, and the server takes a second or two to work one out the
 * first time. Now a page shows what is kept at once, asks again only once it
 * is a minute old, and an ask already on its way is shared, never sent twice.
 */

const FRESH_MS = 60_000;
const kept = new Map<string, { at: number; v: GrowthResponse }>();
const flying = new Map<string, Promise<GrowthResponse>>();

/** The report kept for this ask, however old; undefined before the first answer. */
export function keptGrowth(query: string): GrowthResponse | undefined {
  return kept.get(query)?.v;
}

/** The report for this ask: the kept one while fresh (unless forced), else the answer to one ask, however many wait for it. */
export function loadGrowth(query: string, force = false): Promise<GrowthResponse> {
  const k = kept.get(query);
  if (!force && k && Date.now() - k.at < FRESH_MS) return Promise.resolve(k.v);
  const f = flying.get(query);
  if (f) return f;
  const p = api
    .growth(query)
    .then((v) => {
      kept.set(query, { at: Date.now(), v });
      return v;
    })
    .finally(() => flying.delete(query));
  flying.set(query, p);
  return p;
}

const followed = new Map<string, number>();

/**
 * Whether to ask again in a few seconds: the server answered at once with a
 * report it had kept from before (over 4 minutes old), or one from before
 * the spend, a customer or an order last came in (behind), and is working a
 * newer one out behind it: 总览 read RM7,649 of spend beside 广告's RM7,654.42
 * (2026-10-27). Once a minute at most for an ask, so a server that keeps
 * answering old ones is not asked over and over.
 */
export function askAgainSoon(query: string, g: GrowthResponse): boolean {
  if (!g.built_at || (!g.behind && Date.now() - Date.parse(g.built_at) < 4 * 60_000)) return false;
  if (Date.now() - (followed.get(query) ?? 0) < 60_000) return false;
  followed.set(query, Date.now());
  return true;
}

/** How long after an old answer to ask for the newer one. */
export const ASK_AGAIN_MS = 3000;

/** Forget every kept report: something they count has just changed (an experiment was started). */
export function forgetGrowth(): void {
  kept.clear();
}
